import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getWaitingForDiscountApprovelData = createAsyncThunk(
  '/GetWaitingForDiscountApprovelData',
  async data => {
    const response = await axios.get(
      `/GetWaitingForDiscountApprovelData/${data.StartDate}/${data.EndDate}`
    );
    return response.data;
  }
);

export const GetDiscounts = createAsyncThunk('/getDiscounTypesAndRates', async id => {
  const response = await axios.get(`/getDiscounTypesAndRates`);
  return response.data;
});

export const ApproveWorkOrderDiscount = createAsyncThunk(
  '/ApproveWorkOrderDiscount', async data => {
  const response = await axios.post(`/ApproveWorkOrderDiscount`, data);
  return response.data;
});


const WaitingForDiscountApprovelSlice = createSlice({
  name: 'productExchange',
  initialState: {
    loading: false,
    error: '',
    WorkOrderInformation: []
  },
  reducers: {},
  extraReducers: {
    [getWaitingForDiscountApprovelData.pending]: state => {
      state.loading = true;
    },
    [getWaitingForDiscountApprovelData.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getWaitingForDiscountApprovelData.fulfilled]: (state, action) => {
      state.WorkOrderInformation = action.payload;
      state.loading = false;
    },
    [GetDiscounts.pending]: (state) => {
      state.loading = true;
    },
    [GetDiscounts.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [GetDiscounts.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    },
    [ApproveWorkOrderDiscount.pending]: (state) => {
      state.loading = true;
    },
    [ApproveWorkOrderDiscount.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [ApproveWorkOrderDiscount.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    },
  }
});

export const WaitingForDiscountApprovelSliceActions = WaitingForDiscountApprovelSlice.actions;
export default WaitingForDiscountApprovelSlice;
